export default __webpack_public_path__ + "static/media/Loading.5eb3f1e9.gif";